var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isHeader
    ? _c("th")
    : _c("td", [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.rowData.checked,
              expression: "rowData.checked",
            },
          ],
          key: _vm.rowData.iso639_1,
          attrs: {
            id: `language-settings-checkbox-${_vm.rowData.iso639_1}`,
            type: "checkbox",
            disabled: _vm.rowData.iso639_1 == "en",
          },
          domProps: {
            checked: Array.isArray(_vm.rowData.checked)
              ? _vm._i(_vm.rowData.checked, null) > -1
              : _vm.rowData.checked,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.rowData.checked,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.rowData, "checked", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.rowData,
                      "checked",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.rowData, "checked", $$c)
              }
            },
          },
        }),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }